import { connect, MapDispatchToProps, MapStateToProps } from "react-redux";

import { createSelectLinkAction, createSelectPointAction, createUnselectLinkAction, createUpdateLinksAction } from "../actions";
import { getLink, isAnyPointSelected, isLinkSelected } from "../selectors";
import { IPicassoState, ObjectType, PicassoEditorProps, WrapMapStateToProps } from "../types";
import { LinkComponent, LinkComponentProps } from "./LinkComponent";

type MoveableProps = Pick<LinkComponentProps, "index"> & PicassoEditorProps;

type StateProps = Pick<LinkComponentProps, "link" | "isSelected" | "isAnyPointSelected">;

const mapStateToProps: MapStateToProps<StateProps, MoveableProps, IPicassoState> = (state, { index }) => ({
    link: getLink(state, index),
    isSelected: isLinkSelected(state, index),
    isAnyPointSelected: isAnyPointSelected(state, index),
});

type DispatchProps = Pick<LinkComponentProps, "updateLinks" | "selectLink" | "unselectLink" | "selectPoint">;

const mapDispatchToProps: MapDispatchToProps<DispatchProps, MoveableProps> = (dispatch, { picassoInstanceKey }) => ({
    updateLinks: (changedLinks) => dispatch(createUpdateLinksAction(picassoInstanceKey, changedLinks)),
    selectLink: (link, reselect) => dispatch(createSelectLinkAction(picassoInstanceKey, link, reselect)),
    unselectLink: (linkIndex) => dispatch(createUnselectLinkAction(picassoInstanceKey, linkIndex)),
    selectPoint: (selectedPoint) => dispatch(createSelectPointAction(picassoInstanceKey, selectedPoint)),
});

export const createLink = <S extends ObjectType>(wrapMapStateToProps: WrapMapStateToProps<S>) => connect(wrapMapStateToProps(mapStateToProps), mapDispatchToProps)(LinkComponent);
